/* eslint-disable */
const FETCH_WORKER = 'FETCH_WORKER';

const initialState = null;

export const fetchWorker = (payload) => ({
  type: FETCH_WORKER,
  payload,
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_WORKER:
      return action.payload;
    default:
      return state;
  }
};

export default reducer;